const namespaced = true;

const state = {
  distance: '',
  inOrOut: '',
  possibleAnswers: {
    distance: ['short', 'long'],
    inOrOut: ['in', 'out'],
  },
};

const getters = {
  getDistance: (state) => {
    return state.distance;
  },
  getInOrOut: (state) => {
    return state.inOrOut;
  },
  getType: (state) => {
    let output;
    if (state.distance === '' || state.inOrOut === '') {
      // not all laser use questions answered, not possible to determine use type
      output = 0;
    } else if (state.distance === 'short' && state.inOrOut === 'in') {
      // inside use
      output = 1;
    } else {
      // outside use
      output = 2;
    }
    return output;
  },
  isCompleted: (state) => {
    // find out if all laser use questions have an answer
    // return false if at least one of them has no answer
    return !(
      state.possibleAnswers.distance.indexOf(state.distance) === -1
      ||
      state.possibleAnswers.inOrOut.indexOf(state.inOrOut) === -1
    );
  },
};

const mutations = {
  setDistance: (state, payload) => {
    // state.errors.distance = '';
    state.distance = payload;
  },
  setInOrOut: (state, payload) => {
    // state.errors.inOrOut = '';
    state.inOrOut = payload;
  },
};

const actions = {
  setDistanceShort: ({ commit, rootState }) => {
    commit('setDistance', 'short');
    commit('removeError', rootState.text['0010'], { root: true });
  },
  setDistanceLong: ({ commit, rootState }) => {
    commit('setDistance', 'long');
    commit('removeError', rootState.text['0010'], { root: true });
  },
  setInside: ({ commit, rootState }) => {
    commit('setInOrOut', 'in');
    commit('removeError', rootState.text['0011'], { root: true });
  },
  setOutside: ({ commit, rootState }) => {
    commit('setInOrOut', 'out');
    commit('removeError', rootState.text['0011'], { root: true });
  },
  resetLaserUse: ({ commit }) => {
    commit('setDistance', '');
    commit('setInOrOut', '');
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/laseruse.js